import React from "react";
import { Drawer, DrawerProps, Button, Popconfirm } from "antd";
import ExclamationMark from "assets/icons/exclamationMarkIcon";
import theme from "styles/theme";
import { TabPaneStatusEnum } from "typings/global.types";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled";

interface IDrawerProps extends DrawerProps {
  title?: string;
  icon?: JSX.Element;
  children: any;
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  confirmbuttontxt?: string;
  showConfirmButton?: boolean;
  excludeButtonDisabled?: boolean;
  showExcludeButton?: boolean;
  excludeButtontxt?: string;
  onConfirm?: (ev) => void;
  onExclude?: (ev) => void;
  onFinishVehicle?: (ev) => void;
  customrenderconfirmbutton?: JSX.Element;
  customrendercancelbutton?: JSX.Element;
  disabled: boolean;
  showFinishVehicleButton?: boolean;
  finishVehicleButtontxt?: string;
  tabPaneActive?: TabPaneStatusEnum;
}

interface IFooterProps {
  excludeButtonDisabled?: boolean;
  showExcludeButton?: boolean;
  excludeButtontxt?: string;
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  onClose: (ev) => void;
  confirmbuttontxt?: string;
  showConfirmButton?: boolean;
  onConfirm?: (ev) => void;
  onExclude?: (ev) => void;
  onFinishVehicle?: (ev) => void;
  customrenderconfirmbutton?: JSX.Element;
  customrendercancelbutton?: JSX.Element;
  disabled: boolean;
  showFinishVehicleButton?: boolean;
  finishVehicleButtontxt?: string;
  tabPaneActive?: TabPaneStatusEnum;
}

const Footer = (props: IFooterProps) => {
  const YES_MESSAGE = useTranslation({ id: "yes" });
  const NO_MESSAGE = useTranslation({ id: "no" });
  const CHECKOUT_VEHICLE_MESSAGE = useTranslation({ id: "message_remove_checkin" });
  const FINISH_VEHICLE_MESSAGE = useTranslation({ id: "finish_vehicle_message" });

  return (
    <S.DrawerFooter>
      <div className="left">
        {props.showCancelButton && !props.customrendercancelbutton && (
          <Button onClick={props.onClose} className="btnCancel" disabled={props.disabled}>
            {props.cancelbuttontxt}
          </Button>
        )}
        {props.customrendercancelbutton !== null && props.customrendercancelbutton}
      </div>
      <div className="right row">
        {props.showFinishVehicleButton && (
          <div className="finish-vehicle">
            <Popconfirm
              overlayStyle={{
                width: "310px",
              }}
              title={FINISH_VEHICLE_MESSAGE}
              placement="leftBottom"
              onConfirm={props.onFinishVehicle}
              onCancel={() => false}
              okText={YES_MESSAGE}
              cancelText={NO_MESSAGE}
              disabled={props.disabled}
            >
              <Button
                className="btnFinishVehicle"
                disabled={props.disabled}
                style={{
                  backgroundColor: props.disabled ? "none" : theme["@danger-color"],
                  marginRight: !props.showConfirmButton && "-30px",
                }}
              >
                <ExclamationMark style={{ color: props.disabled ? "black" : "white" }} />
                {props.finishVehicleButtontxt}
              </Button>
            </Popconfirm>
          </div>
        )}
        <div className="col-sm">
          {props.showExcludeButton && props.tabPaneActive !== TabPaneStatusEnum.Items && (
            <Popconfirm title={CHECKOUT_VEHICLE_MESSAGE} placement="leftBottom" onConfirm={props.onExclude} onCancel={() => false} okText={YES_MESSAGE} cancelText={NO_MESSAGE}>
              <Button className="btnExclude" disabled={props.disabled}>
                <ExclamationMark style={{ color: props.disabled ? "black" : "white" }} />
                {props.excludeButtontxt}
              </Button>
            </Popconfirm>
          )}
        </div>
        <div className="col-sm">
          {props.customrenderconfirmbutton !== null && props.tabPaneActive !== TabPaneStatusEnum.Items && props.customrenderconfirmbutton}
          {props.showConfirmButton && !props.customrenderconfirmbutton && props.tabPaneActive !== TabPaneStatusEnum.Items && (
            <Button type="primary" onClick={props.onConfirm} className="btn" disabled={props.disabled} loading={props.disabled}>
              {props.confirmbuttontxt}
            </Button>
          )}
        </div>
      </div>
    </S.DrawerFooter>
  );
};

Footer.defaultProps = {
  excludeButtonDisabled: false,
  showExcludeButton: false,
  showFinishVehicleButton: false,
  excludeButtontxt: "Exclude",
  cancelbuttontxt: "cancel",
  finishVehicleButtontxt: "Finish vehicle",
  showCancelButton: true,
  confirmbuttontxt: "Ok",
  showConfirmButton: true,
  disabled: false,
  tabPaneActive: TabPaneStatusEnum.Info,
};

const Title = ({ label }) => {
  return <S.Title>{label}</S.Title>;
};

const YmsDrawer = (props: IDrawerProps) => {
  return (
    <Drawer
      {...props}
      title={<Title label={props.title} />}
      footer={
        <Footer
          cancelbuttontxt={props.cancelbuttontxt}
          showCancelButton={props.showCancelButton}
          onClose={props.onClose}
          confirmbuttontxt={props.confirmbuttontxt}
          showConfirmButton={props.showConfirmButton}
          onConfirm={props.onConfirm}
          onExclude={props.onExclude}
          excludeButtontxt={props.excludeButtontxt}
          excludeButtonDisabled={props.excludeButtonDisabled}
          showExcludeButton={props.showExcludeButton}
          customrenderconfirmbutton={props.customrenderconfirmbutton}
          customrendercancelbutton={props.customrendercancelbutton}
          disabled={props.disabled}
          finishVehicleButtontxt={props.finishVehicleButtontxt}
          showFinishVehicleButton={props.showFinishVehicleButton}
          onFinishVehicle={props.onFinishVehicle}
          tabPaneActive={props.tabPaneActive}
        />
      }
    >
      {props.children}
    </Drawer>
  );
};

YmsDrawer.defaultProps = {
  title: "Default title",
};

export default YmsDrawer;
